// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatioWrapper_root__1rNsr","aspectPadding":"AspectRatioWrapper_aspectPadding__2R8fo","aspectBox":"AspectRatioWrapper_aspectBox__2Enl0"};